import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tournament-card" }
const _hoisted_2 = { class: "tournament-card__wrapper" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = {
  key: 0,
  class: "participant-result"
}
const _hoisted_7 = { class: "place" }
const _hoisted_8 = { class: "prize" }
const _hoisted_9 = { class: "amount hidden" }
const _hoisted_10 = { class: "amount" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "controls"
}
const _hoisted_14 = {
  key: 1,
  class: "controls"
}
const _hoisted_15 = {
  key: 1,
  disabled: "",
  class: "btn btn-secondary btn-claim"
}
const _hoisted_16 = {
  key: 2,
  class: "d-flex gap-sm justify-content-between"
}
const _hoisted_17 = {
  key: 0,
  class: "won-results"
}
const _hoisted_18 = { class: "amount" }
const _hoisted_19 = { class: "icon" }
const _hoisted_20 = ["src"]

import TournamentDTO from "@/models/TournamentDTO";
import {computed, onMounted, ref, watch} from "vue";
import {tournamentName} from "@/models/enum/TournamentType";
import {numberFormatter} from "@/service/NumberFormatter";
import {endedLabelText, startInLabelText, timeLeftLabelText} from "@/service/DateHelper";
import {$t} from "@/i18n";
import {TournamentStatus} from "@/models/enum/TournamentStatus";
import {useStore} from "vuex";
import {AppEvents} from "@/models/enum/AppEvents";
import {useRouter} from "vue-router";
import TournamentParticipantDTO from "@/models/TournamentParticipantDTO";
import SvgIcon from "@/components/SvgIcon.vue";
import {isZero} from "@/models/MoneyDTO";
import {api} from "@/service/APIClient";
import {useNotification} from "@kyvg/vue3-notification";
import {reactive} from "@vue/reactivity";


export default /*@__PURE__*/_defineComponent({
  __name: 'TournamentCard',
  props: {
    item: {},
    participant: {}
  },
  setup(__props: any) {

const props = __props

const store = useStore()
const router = useRouter()
const state = reactive({
  claimInProgress: false as boolean
})
const notification = useNotification()
const displayValue = ref(props.item.currentBankroll.amount);
let from: number = 0
let to: number = 0
let start = performance.now();
let isAnimationInProgress = false

function animateValue(duration = 14000) {
  isAnimationInProgress = true

  function frame(now: number) {
    const progress = Math.min((now - start) / duration, 1);
    const value = from + (to - from) * progress;

    displayValue.value = Math.floor(value).toString()
    if (progress < 1) {
      requestAnimationFrame(frame);
    } else {
      isAnimationInProgress = false
    }
  }

  requestAnimationFrame(frame);
}

onMounted(() => {
  if (props.item.status === TournamentStatus.ACTIVE && props.item.startBankroll.amount !== props.item.currentBankroll.amount) {
    to = Number.parseFloat(props.item.currentBankroll.amount);
    from = to - 500;
    start = performance.now();

    animateValue();
  }
})

watch(() => props.item.currentBankroll.amount, (newVal, oldVal) => {
    to = Number.parseFloat(newVal);
    from = Number.parseFloat(oldVal);
    start = performance.now();

    if (to > from && !isAnimationInProgress) {
      animateValue();
    } else {
      displayValue.value = newVal;
    }
  }
);

const claim = async (participant: TournamentParticipantDTO) => {
  try {
    state.claimInProgress = true
    await api.call.tournaments.claim(participant.tournamentId)
    store.dispatch('updateUser')
    const text = $t('amount_added_to_balance', {amount: numberFormatter.formatNumber(participant.prize)});
    notification.notify({type: 'success', title: `<div class="d-flex align-items-center gap-1"><img src="/img/coins/gold_coin.svg"> ${text}</div>`, duration: 1500})
    participant.isPrizeClaimed = true
  } catch (e) {

  } finally {
    state.claimInProgress = false
  }
}

const showResults = async (item: TournamentDTO) => {
  router.push({name: 'tournamentInfo', params: {id: item.id}, })
}

const join = async (item: TournamentDTO) => {
  if (!store.getters.isLoggedIn) {
    router.push({name: 'login'})
    return;
  }
  store.dispatch('joinTournament', item.id)
  store.dispatch('emit', {event: AppEvents.SHOW_SELECT_GAME_TO_PLAY})
}

const type = computed(() => {
  return tournamentName(props.item.type)
})

const durationLabel = computed(() => {
  switch (props.item.status) {
    case TournamentStatus.ACTIVE: return timeLeftLabelText(props.item.endAt)
    case TournamentStatus.ANNOUNCEMENT: return startInLabelText(props.item.startAt)
    case TournamentStatus.COMPLETED: return endedLabelText(props.item.endAt)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([[type.value, _ctx.item.status === _unref(TournamentStatus).COMPLETED ? 'completed' : ''], "tournament-card__item"]),
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showResults(_ctx.item)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)(`tournament_names.${type.value}`)), 1),
            (_ctx.participant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.participant.place), 1),
                  _createVNode(SvgIcon, { icon: "menu/tournaments" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[4] || (_cache[4] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(numberFormatter).formatNumber(displayValue.value)?.replaceAll(/\d/g, '0')) + "0", 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(numberFormatter).formatNumber(displayValue.value)), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[5] || (_cache[5] = _createElementVNode("img", { src: "/img/timer.svg" }, null, -1)),
            _createElementVNode("span", {
              class: "duration",
              innerHTML: durationLabel.value
            }, null, 8, _hoisted_12)
          ]),
          (_ctx.item.status === _unref(TournamentStatus).ACTIVE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (join(_ctx.item)), ["stop"])),
                  type: "button",
                  class: "btn btn-primary text-capitalize-first"
                }, _toDisplayString(!_ctx.item.isJoined ? _unref($t)('join') : _unref($t)('play')), 1)
              ]))
            : (_ctx.item.status === _unref(TournamentStatus).COMPLETED)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_ctx.participant && !_ctx.participant.isPrizeClaimed && !_unref(isZero)(_ctx.participant.prize) && !_unref(state).claimInProgress)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (claim(_ctx.participant)), ["stop"])),
                        type: "button",
                        class: "btn btn-primary btn-claim text-capitalize-first"
                      }, [
                        _createTextVNode(_toDisplayString(_unref($t)('claim')) + " ", 1),
                        _cache[6] || (_cache[6] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(_ctx.participant.prize)), 1)
                      ]))
                    : (_unref(state).claimInProgress)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_15, [
                          _createVNode(SvgIcon, { icon: "loader-icon" }),
                          _createTextVNode(" " + _toDisplayString(_unref($t)('claiming')), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showResults(_ctx.item)), ["stop"])),
                            type: "button",
                            class: "btn btn-secondary text-capitalize-first"
                          }, _toDisplayString(_unref($t)('results')), 1),
                          (_ctx.participant)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createTextVNode(_toDisplayString(_unref($t)('you_won')) + " ", 1),
                                _cache[8] || (_cache[8] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                                _cache[9] || (_cache[9] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(numberFormatter).formatNumber(_ctx.participant.prize)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                ]))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("img", {
            src: `/img/tournaments/icons/${type.value}.png`
          }, null, 8, _hoisted_20)
        ])
      ], 2)
    ])
  ]))
}
}

})